
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2r0OO", function(module, exports) {
/* CwrWelcomeBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");




const $113daf0dd7ff69a1$export$631cbd1d869e1777 = (0, $kSwu1.defineMessages)({
    bannerWelcomeMessage: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading",
        defaultMessage: "Welcome to Confluence"
    },
    bannerWelcomeMessageWithName: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading.with-name",
        defaultMessage: "Welcome to Confluence, {firstName}"
    },
    bannerPersonalSpaceSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.personal-space.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas."
    },
    bannerSharedSpaceSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.shared-space.subtext",
        defaultMessage: "You've landed in a Confluence space. Use this area to build project plans, team handbooks, and anything else you want to share with the team."
    },
    bannerLiveDocSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.live-doc.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas."
    },
    bannerHomeSubtext: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.home.subtext",
        defaultMessage: "Use Confluence to create and share knowledge with your team. This is your Home page, a personalized view of the latest updates from your team."
    },
    bannerDismissLabel: {
        id: "experiment-cwr-nth-user-onboarding.cwr-welcome-banner.dismiss",
        defaultMessage: "Dismiss banner"
    }
});


var $3936e49add80bf06$exports = {};
$3936e49add80bf06$exports = new URL("LightWelcomeImage.b703b601.png", import.meta.url).toString();


var $39a27b59fa609549$exports = {};
$39a27b59fa609549$exports = new URL("DarkWelcomeImage.ebbc9b04.png", import.meta.url).toString();


const $680a9df222753f1b$export$cc62c17e0857f7f7 = 'cwrWelcome';


const $57d88de957aaaec2$var$CWR_WELCOME_VARIANTS = [
    'personalSpace',
    'sharedSpace',
    'liveDoc'
];
const $57d88de957aaaec2$var$isCwrWelcomeVariant = (value)=>!!value && $57d88de957aaaec2$var$CWR_WELCOME_VARIANTS.includes(value);
const $57d88de957aaaec2$var$useCwrWelcomeParam = (0, $dPJCf.createSingleQueryParamHook)((0, $680a9df222753f1b$export$cc62c17e0857f7f7));
const $57d88de957aaaec2$var$unboundedStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL4p0Oa _2bqfgdOeNX _1x1D3gOeNX _39xV02j8JR _2XsHFM5ksT _0KLXruVva3 _0jFU0VymWf _1mT5xdRAKS",
    headingStyles: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3iDTPbgJ9S _4Gn54R7dHp _1U1ZhbbI28",
    subtextStyles: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28",
    livePageStyle: "_2bqfgdYbGa _2XsHFMPgdg _39xV02IZbP"
};
const $57d88de957aaaec2$var$styles = {
    contentContainerStyles: "_2mHwu82ADO _4FKVYENHnM _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _42Yu6B7dHp _39xV02ygnw",
    svgContainer: "_39xV02iLlu _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa",
    closeButton: "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdIZbP"
};
const $57d88de957aaaec2$var$SUBTEXT_BY_VARIANT = {
    personalSpace: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerPersonalSpaceSubtext,
    sharedSpace: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerSharedSpaceSubtext,
    liveDoc: (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerLiveDocSubtext
};
const $57d88de957aaaec2$var$CwrWelcomeBannerContent = ({ isLivePage: isLivePage, variant: variant })=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstName = displayName?.split(' ')[0] ?? null;
    (0, $cozmU.useEffect)(()=>{
        if (!isDismissed) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'cwrWelcomeBanner',
                attributes: {
                    variant: variant
                }
            }
        }).fire();
         // `variant` is stable per-mount; omitted to avoid a redundant re-fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'cwrWelcomeBanner',
                source: 'viewPageContentContainer',
                attributes: {
                    variant: variant
                }
            }
        }).fire();
        setQueryParams({
            [(0, $680a9df222753f1b$export$cc62c17e0857f7f7)]: undefined
        });
    };
    if (isDismissed) return null;
    const subtextMessage = $57d88de957aaaec2$var$SUBTEXT_BY_VARIANT[variant];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "cwr-welcome-banner",
        className: (0, $hekY6.default)([
            $57d88de957aaaec2$var$unboundedStyles.root,
            isLivePage && $57d88de957aaaec2$var$unboundedStyles.livePageStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($57d88de957aaaec2$var$styles.contentContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57d88de957aaaec2$var$unboundedStyles.headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, firstName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerWelcomeMessageWithName,
        values: {
            firstName: firstName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerWelcomeMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $57d88de957aaaec2$var$unboundedStyles.subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtextMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($57d88de957aaaec2$var$styles.svgContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3936e49add80bf06$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($39a27b59fa609549$exports))),
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($57d88de957aaaec2$var$styles.closeButton)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "cwr-welcome-banner-button-close",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $113daf0dd7ff69a1$export$631cbd1d869e1777).bannerDismissLabel),
        onClick: handleDismiss
    })));
};
const $57d88de957aaaec2$var$CwrWelcomeBannerInner = ({ contentId: contentId, isLivePage: isLivePage })=>{
    const cwrWelcomeParam = $57d88de957aaaec2$var$useCwrWelcomeParam();
    const isValidBannerRoute = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
    const variant = $57d88de957aaaec2$var$isCwrWelcomeVariant(cwrWelcomeParam) ? cwrWelcomeParam : null;
    const shouldRenderBanner = isValidBannerRoute && !!contentId && variant !== null;
    if (!shouldRenderBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57d88de957aaaec2$var$CwrWelcomeBannerContent, {
        isLivePage: isLivePage,
        variant: variant
    });
};
const $57d88de957aaaec2$export$fa7cecb87e076447 = ({ contentId: contentId, isLivePage: isLivePage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57d88de957aaaec2$var$CwrWelcomeBannerInner, {
        contentId: contentId,
        isLivePage: isLivePage
    }));
module.exports["CwrWelcomeBanner"] = $57d88de957aaaec2$export$fa7cecb87e076447;

});


//# sourceMappingURL=CwrWelcomeBanner.0cb702e3.js.map
